import { collection, getDocs, onSnapshot, query, where } from 'firebase/firestore';
import { useEffect, useState } from 'react';

import { firestore } from '../../../../App/firebase';

type Summary = {
  retailName: string;
  employeeName: string;
  discountAmount: 0;
  grandTotal: 0;
  totalPaidAmount: 0;
  totalProductCost: 0;
  unpaidTotal: 0;
  sales: 0;
};

type EmployeeSummary = { [retail: string]: Summary };
type EmployeeSummaries = { [employee: string]: EmployeeSummary };

type Stats = {
  employeeSummaries: EmployeeSummaries;
  retailNames: { [retailUID: string]: string };
};

export default () => {
  const [stats, setStats] = useState<Stats>();
  const [admins, setAdmins] = useState<string[]>();

  useEffect(() => {
    if (!admins) {
      return () => {};
    }

    const q = query(
      collection(firestore, "forms_v2"),
      where("archived", "==", false)
    );

    return onSnapshot(q, (snapshot) => {
      const employeeSummaries: EmployeeSummaries = {};
      const retailNames: { [retailUID: string]: string } = {};

      snapshot.forEach((doc) => {
        const {
          summary: docSummary,
          employeeNames,
          creator,
          creatorName,
        } = doc.data()!;
        const employeeName = employeeNames[0];

        if (!docSummary) {
          return;
        }

        if (admins?.includes(creator)) {
          return;
        }

        if (!employeeSummaries[employeeName]) {
          employeeSummaries[employeeName] = {};
        }

        if (!employeeSummaries[employeeName][creator]) {
          employeeSummaries[employeeName][creator] = {
            employeeName,
            retailName: creatorName,
            discountAmount: 0,
            grandTotal: 0,
            totalPaidAmount: 0,
            totalProductCost: 0,
            unpaidTotal: 0,
            sales: 0,
          };
        }

        retailNames[creator] ??= creatorName;

        const summary = employeeSummaries[employeeName][creator];
        summary.sales += 1;

        Object.keys(docSummary).forEach((key) => {
          if (key in summary) {
            (summary as any)[key] += docSummary[key] || 0;
          }
        });
      });

      setStats({
        employeeSummaries,
        retailNames,
      });
    });
  }, [admins]);

  useEffect(() => {
    getDocs(collection(firestore, "users")).then(({ docs }) => {
      setAdmins(
        docs.filter((doc) => doc.data()?.admin === true).map((doc) => doc.id)
      );
    });
  }, []);

  return stats;
};
